import React from 'react';
import PropTypes from 'prop-types';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './pager.css';

/* Pager — "1–100 of 1,234" with previous / next, SP-main's `.sd-pager`.

   Server-paged: the page holds `perPage` rows and the API holds the rest, so
   without this a catalogue larger than one page has rows nobody can reach. */
export default function Pager({ page, perPage, total, onPageChange }) {
  if (!total) return null;
  const pages = Math.max(1, Math.ceil(total / perPage));
  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);

  return (
    <nav className="sd-pager" aria-label="Pagination">
      <span className="sd-pginfo">
        <b>{start.toLocaleString()}–{end.toLocaleString()}</b> of <b>{total.toLocaleString()}</b>
      </span>
      <div className="sd-pgnav">
        <button
          className="sd-pgbtn"
          type="button"
          aria-label="Previous page"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
        >
          <ChevronLeft aria-hidden="true" />
        </button>
        <button
          className="sd-pgbtn"
          type="button"
          aria-label="Next page"
          disabled={page >= pages}
          onClick={() => onPageChange(page + 1)}
        >
          <ChevronRight aria-hidden="true" />
        </button>
      </div>
    </nav>
  );
}

Pager.propTypes = {
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  total: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
};
